
const { search } = window.location;
const tokenParams = sessionStorage.getItem('tokenParams');
export const isMSDKV5 = () => {
    const str = tokenParams || search;
    if (!str) {
      return false;
    }
    return str.lastIndexOf('itopencodeparam') > -1;
  };

export const getParamsByKey = (name, url = '') => {
    url = url || sessionStorage.tokenParams || location.search;
    url = url.replace(/\'|\"|\<|\>/, '');
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    const r = url.substr(url.indexOf('?') + 1).match(reg);
    if (r != null) {
      return r[2];
    }
    return '';
  };

export function isHarmonyOS() {
    const ua = navigator.userAgent.toLowerCase();
    return /harmony/i.test(ua) || /huawei/i.test(ua) || /hmscore/i.test(ua)
    
}